// import React, { Suspense } from "react";
// import Image from "react-image-enlarger";
// import { Img } from "react-image";
// function ImageView({ src, title }) {
//   const [zoomed, setZoomed] = React.useState(false);

//   return (
//     <Suspense>
//       {zoomed ? (
//         <div style={{ marginRight: 16 }}>
//           <span>{title}</span>
//           <Image
//             style={{ width: "150px", height: "150px" }}
//             zoomed={zoomed}
//             src={src}
//             onClick={() => setZoomed(true)}
//             onRequestClose={() => setZoomed(false)}
//           />
//         </div>
//       ) : (
//         <div style={{ marginRight: 16 }}>
//           <span>{title}</span>
//           <Img
//             style={{ width: "150px", height: "150px" }}
//             zoomed={zoomed}
//             src={src}
//             onClick={() => setZoomed(true)}
//             onRequestClose={() => setZoomed(false)}
//           />
//         </div>
//       )}
//     </Suspense>
//   );
// }

// export default ImageView;

import React, { useState } from "react";
import { Dialog, IconButton } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function ImageView({ src, title }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div style={{}}>
      <span
        style={{
          display: "block",
          marginBottom: "8px",
          fontWeight: 500,
          color: "#333",
        }}
      >
        {title}
      </span>

      {/* Thumbnail */}
      <img
        src={src}
        alt={title}
        onClick={handleOpen}
        style={{
          width: 100,
          height: 100,
          objectFit: "cover",
          borderRadius: 8,
          cursor: "zoom-in",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      />

      {/* Fullscreen Modal */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.9)",
            boxShadow: "none",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px 16px",
            position: "absolute",
            right: 0,
            top: 0,
            zIndex: 20,
          }}
        >
          <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </div>

        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <TransformWrapper
            initialScale={1}
            minScale={0.5}
            maxScale={6}
            wheel={{ step: 0.3 }}
            doubleClick={{ step: 1.5 }}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                {/* Zoom Controls */}
                <div
                  style={{
                    position: "absolute",
                    top: 20,
                    left: 20,
                    display: "flex",
                    gap: 8,
                    background: "rgba(255,255,255,0.1)",
                    padding: "6px 10px",
                    borderRadius: 8,
                    zIndex: 10,
                  }}
                >
                  <IconButton
                    onClick={() => zoomIn()}
                    sx={{ color: "white" }}
                    size="small"
                  >
                    <ZoomInIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => zoomOut()}
                    sx={{ color: "white" }}
                    size="small"
                  >
                    <ZoomOutIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => resetTransform()}
                    sx={{ color: "white" }}
                    size="small"
                  >
                    <RestartAltIcon />
                  </IconButton>
                </div>

                <TransformComponent>
                  <img
                    src={src}
                    alt={title}
                    style={{
                      maxWidth: "90vw",
                      maxHeight: "90vh",
                      objectFit: "contain",
                      userSelect: "none",
                      cursor: "grab",
                    }}
                    draggable={false}
                  />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </div>
      </Dialog>
    </div>
  );
}

export default ImageView;
